import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    mobile: {
      desktop: {
        padding: 100,
      },
      smartphone: {
        padding: 20,
      },
    },
  },
  HEADLINE: {
    textAlign: "center",
    fontSize: "32pt",
    fontFamily: theme.fontFamily,
    fontWeight: "bold" as "bold",
  },
  TEXT: {
    textAlign: "center",
    padding: 20,
    fontSize: "13pt",
    fontFamily: theme.fontFamily,
    lineHeight: "18pt",
  },
  ICON: {
    borderRadius: "100%",
    backgroundColor: "transparent",
    padding: 10,
    color: theme.backgroundColor,
    border: `1px solid ${theme.backgroundColor}`,
    marginBottom: 20,
    display: "inline-block",
    textAlign: "center",
  },
};
